/**
 * LockBadge — mostra estado do lock (JA: 1 user por ordem).
 * Se locked por outro, mostra "🔒 locked by X" + botão force-release (admin).
 */
import { useState } from 'react';
import api from '../../../services/api.js';

const LockBadge = ({ orderId, lock }) => {
  const [forceModal, setForceModal] = useState(false);
  const [reason, setReason] = useState('');

  if (lock.loading) return <span className="gencrm_lock-badge gencrm_lock-badge--loading">A adquirir lock…</span>;
  if (!lock.locked) return null;

  if (lock.isMine) {
    return <span className="gencrm_lock-badge gencrm_lock-badge--mine">🔒 Sessão ativa</span>;
  }

  // Locked por outro user
  return (
    <>
      <span className="gencrm_lock-badge gencrm_lock-badge--other">
        🔒 Bloqueada por <strong>{lock.holder}</strong>
      </span>
      <button
        className="gencrm_btn gencrm_btn--xs"
        onClick={() => setForceModal(true)}
        title="Forçar libertação (admin)"
      >
        Force unlock
      </button>

      {forceModal && (
        <div className="gencrm_modal_overlay" onClick={() => setForceModal(false)}>
          <div className="gencrm_modal" onClick={(e) => e.stopPropagation()}>
            <div className="gencrm_modal__header">
              <h3>Forçar libertação de lock</h3>
            </div>
            <div className="gencrm_modal__body">
              <p>Tem a certeza? O user <strong>{lock.holder}</strong> está a editar.</p>
              <textarea
                className="gencrm_field_input"
                rows={2}
                placeholder="Motivo (obrigatório para auditoria)"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
              <div className="gencrm_modal__footer">
                <button className="gencrm_btn" onClick={() => setForceModal(false)}>Cancelar</button>
                <button
                  className="gencrm_btn gencrm_btn--danger"
                  disabled={!reason.trim()}
                  onClick={async () => {
                    await api.post(`/orders/${orderId}/lock/force-release`, { reason });
                    setForceModal(false);
                    window.location.reload();
                  }}
                >
                  Forçar libertação
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LockBadge;
